import { useContext } from "react";
import { useParams } from "react-router-dom";
import { ShopContext } from "../Context/ShopContext";
import Breadcrum from "../Components/Breadcrums/Breadcrum";
import PD from "../Components/PD/PD";
import RelatedProducts from "../Components/RelatedProduct/RelatedProducts";
import DescriptionBox from "../Components/DescriptionBox/DescriptionBox";
const Product = () => {
  const { all_product } = useContext(ShopContext); // Provide default empty array
  const { productId } = useParams();
  
  const product = all_product.find((e) => e.id === Number(productId)); // Ensure productId is an integer   

  return (
    <div>
      <Breadcrum product={product} />
      <PD product={product} />
      <DescriptionBox />
      <RelatedProducts/>
    </div>
  );
};

export default Product;